import * as React from 'react';
import { MapData } from '../store/MapData';

export const MapDataContext = React.createContext<MapData>(new MapData({}));

export const MapDataProvider = MapDataContext.Provider;
export const MapDataConsumer = MapDataContext.Consumer;

export const useMapData = () => React.useContext(MapDataContext);
